import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { Outlet, useNavigate, useLocation, useParams } from "react-router-dom"; // Thêm useLocation
import { useTranslation } from "react-i18next";
import React from "react";

const CustomerLayout = () => {
  const { t } = useTranslation();
  const { fanpage_id } = useParams();
  const navigate = useNavigate();
  const location = useLocation(); // Lấy thông tin location hiện tại

  const menuItems = [
    { text: t("customer.tabs.tabTitle1"), icon: <ArrowRightIcon />, link: "customer" },
    { text: t("customer.tabs.tabTitle2"), icon: <ArrowRightIcon />, link: "scan-old-customer" },
    { text: t("customer.tabs.tabTitle3"), icon: <ArrowRightIcon />, link: "send-customer-care-message" },
    { text: t("customer.tabs.tabTitle4"), icon: <ArrowRightIcon />, link: "campaign" },
  ];
  
  return (
    <Container maxWidth="xl" className="m-t-40">
      {/* <p>
        <Button
          className="text-transform"
          startIcon={<ArrowBackRoundedIcon />}
          variant="contained"
          color="inherit"
          onClick={() => navigate("/dashboard")}
        >
          {t("common.back")}
        </Button>
      </p> */}
      <Grid container spacing={2}>
        <Grid item xs={12} md={2}>
          <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
            <List disablePadding>
              <Divider />
              {menuItems.map((item, index) => {
                const absolutePath = `/dashboard/${fanpage_id}/${item.link}`;
      
                // 2. Kiểm tra active chính xác bằng đường dẫn tuyệt đối
                const isActive = location.pathname === absolutePath;

                return (
                  <React.Fragment key={index}>
                    <ListItem disablePadding>
                      <ListItemButton 
                        onClick={() => navigate(absolutePath)}
                        selected={isActive} // Thuộc tính quan trọng của MUI để hiện trạng thái Active
                        sx={{
                          // Tùy chỉnh màu sắc khi active nếu muốn
                          "&.Mui-selected": {
                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                            borderRight: "4px solid #1976d2",
                            "&:hover": {
                              backgroundColor: "rgba(25, 118, 210, 0.12)",
                            },
                            "& .MuiListItemText-primary": {
                              color: "#1976d2",
                              fontWeight: "bold",
                            },
                            "& .MuiListItemIcon-root": {
                              color: "#1976d2",
                            }
                          }
                        }}
                      >
                        <ListItemIcon sx={{ minWidth: 20 }}>{item.icon}</ListItemIcon>
                        <ListItemText primary={item.text} />
                      </ListItemButton>
                    </ListItem>
                    <Divider />
                  </React.Fragment>
                );
              })}
            </List>
          </Box>
        </Grid>
        <Grid item xs={12} md={10}>
          <Box sx={{ p: 2, bgcolor: "background.paper", borderRadius: 1 }}>
             <Outlet />
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default CustomerLayout;